import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { GlobalStyles, KeyboardDetectionProvider } from '@spotify-internal/encore-web';

import { initialize as initSentry } from 'lib/client/sentry/sentry';
import MarketInfoProvider, { getLocaleForMarket, initiateMarket } from 'context/MarketInfo/MarketInfoProvider';
import ConfigProvider from 'context/Config/ConfigProvider';
import UserInfoProvider from 'context/UserInfo/UserInfoProvider';
import RemoteConfigProvider from 'context/Experimentation/ExperimentationProvider';
import { initI18n } from 'lib/shared/i18n/i18n';
import App from 'containers/App/App';

import './index.scss';

initSentry();

const market = initiateMarket();
initI18n(getLocaleForMarket(market));

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react');
  axe(React, ReactDOM, 1000);
}

ReactDOM.render(
  <>
    <GlobalStyles />
    <Router basename={market}>
      <HelmetProvider>
        <MarketInfoProvider market={market}>
          <ConfigProvider>
            <UserInfoProvider>
              <RemoteConfigProvider>
                <KeyboardDetectionProvider>
                  <App market={market} />
                </KeyboardDetectionProvider>
              </RemoteConfigProvider>
            </UserInfoProvider>
          </ConfigProvider>
        </MarketInfoProvider>
      </HelmetProvider>
    </Router>
  </>,
  document.getElementById('root'),
);
